import { Box, Typography } from "@mui/material";
import QRCode from "react-qr-code";

type Props = {
  /** Venue (or fallback) label printed on the poster. */
  venueLabel: string;
  /** Same bot chat wa.me URL for every venue — no per-venue payload. */
  chatUrl: string | null;
  miqaatName?: string | null;
};

/**
 * Printable check-in poster: venue label + shared bot WhatsApp QR.
 * P3 self-scan reuses this component; do not encode venue ids in the QR.
 */
export default function MiqaatBotChatPoster({ venueLabel, chatUrl, miqaatName }: Props) {
  return (
    <Box
      sx={{
        p: 2,
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        bgcolor: "background.paper",
        textAlign: "center",
        maxWidth: 280,
        "@media print": {
          breakInside: "avoid",
        },
      }}
    >
      {miqaatName ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
          {miqaatName}
        </Typography>
      ) : null}
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
        {venueLabel}
      </Typography>
      {chatUrl ? (
        <Box
          sx={{
            display: "inline-flex",
            p: 1.5,
            bgcolor: "common.white",
            borderRadius: 1,
            mb: 1.5,
          }}
        >
          <QRCode value={chatUrl} size={160} />
        </Box>
      ) : (
        <Typography variant="body2" color="error" sx={{ mb: 1.5 }}>
          Set WhatsApp bot phone in Cron → Runtime settings to generate the bot QR.
        </Typography>
      )}
      <Typography variant="body2" color="text.primary" sx={{ lineHeight: 1.4 }}>
        Scan, tap Send, then share your live location to check in.
      </Typography>
    </Box>
  );
}
